import { memo } from 'react';

import { ICON_PATHS, type IconName } from './icons';

interface IconProps {
  readonly name: IconName;
  /** Rendered size in CSS pixels. Defaults to the surrounding font size. */
  readonly size?: number;
  readonly className?: string;
}

/**
 * Decorative by default: hidden from assistive technology, because every
 * icon on this site sits beside text that already says what it means. An
 * icon-only control must carry its own aria-label.
 */
export const Icon = memo(({ name, size, className }: IconProps) => (
  <svg
    className={className}
    width={size ?? '1em'}
    height={size ?? '1em'}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {ICON_PATHS[name].map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
));

Icon.displayName = 'Icon';
